import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

interface AuthResponse {
    clientPrincipal?: {
        identityProvider: string;
        userId: string;
        userDetails: string;
        userRoles: string[];
    };
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private authUrl = '/.auth/me'; // Azure SWA auth endpoint
    private loginUrl = '/.auth/login/taxisnet'; // Login URL
    private logoutUrl = '/.auth/logout'; // Logout URL

    public userSubject = new BehaviorSubject<AuthResponse | null>(null);
    public user$: Observable<AuthResponse | null> = this.userSubject.asObservable();

    constructor(private http: HttpClient, private router: Router) { }

    /** Check if user is authenticated */
    checkAuth(): Observable<AuthResponse | null> {
        return this.http.get<AuthResponse>(this.authUrl).pipe(
            tap(response => {
                console.log('AuthService: Received user authentication data', response);
                if (response.clientPrincipal) {
                    this.userSubject.next(response);
                } else {
                    this.userSubject.next(null);
                }
            })
        );
    }

    /** Redirect to Azure Static Web Apps authentication */
    login() {
        console.log('AuthService: Redirecting to login...');
        window.location.href = this.loginUrl;
    }

    /** Logout and clear session */
    logout() {
        console.log('AuthService: Logging out...');
        window.location.href = this.logoutUrl;
    }
}
